import { IStudentRow } from 'types';
import { safeLocalStorageGet } from '../localStorage';

// Jira story https://enroly.atlassian.net/browse/DTJ-788 created for this
// TODO elevate this type to types package. Ensure the creation of these values in query string and local storage are using this type.
// None are used in place of an error handle
type InstitutionType = 'uni' | 'pathway' | 'all' | 'none';

export const bulkActionGetInstitutionType = (
  allStudentsSelected: boolean,
  selectedStudents: IStudentRow[],
  isPathway?: boolean,
): InstitutionType => {
  if (allStudentsSelected) {
    const params = new URLSearchParams(window.location.search);

    const defaultType = isPathway ? 'pathway' : 'uni';

    return (
      (params.get('institution') as InstitutionType) ||
      (safeLocalStorageGet('dashboard-uni-institution-value') as InstitutionType) ||
      defaultType
    );
  }

  return getInstitutionType(selectedStudents);
};

const getInstitutionType = (selectedStudents: IStudentRow[]): InstitutionType => {
  const types = [...new Set(selectedStudents.map(student => (student.pathway ? 'pathway' : 'uni')))];
  switch (types.length) {
    case 0:
      return 'none';
    case 1:
      return types[0];
    default:
      return 'all';
  }
};
